import React from 'react';

interface SquareCheckboxIconProps {
  onClick?: () => void;
  checked?: boolean;
}

const SquareCheckboxIcon = ({
  onClick,
  checked = false,
}: SquareCheckboxIconProps) => {
  return (
    <svg
      onClick={onClick}
      style={{ cursor: 'pointer' }}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M0.5 1C0.5 0.723858 0.723858 0.5 1 0.5H19C19.2761 0.5 19.5 0.723858 19.5 1V19C19.5 19.2761 19.2761 19.5 19 19.5H1C0.723858 19.5 0.5 19.2761 0.5 19V1Z"
        stroke="#DDE1E8"
      />
      {checked && (
        <path
          d="M4 5C4 4.44772 4.44772 4 5 4H15C15.5523 4 16 4.44772 16 5V15C16 15.5523 15.5523 16 15 16H5C4.44772 16 4 15.5523 4 15V5Z"
          fill="#F5431D"
        />
      )}
    </svg>
  );
};

export default SquareCheckboxIcon;
